/* istanbul ignore file */
import React, { useState } from "react";
import PropTypes from "prop-types";

import { Collapse, TableCell, TableRow } from "@material-ui/core/";

import classes from "../GenomeTable.module.css";

import ProposalTableCells from "./ProposalTableCells";
import ProposalMetadata from "./ProposalMetadata";

const ProposalRow = (props) => {
  const { row, proposalMetaList, setProposalMetaList } = props;

  const [isHovering, setHovering] = useState(false);

  const enter = () => {
    setHovering(true);
  };

  const leave = () => {
    setHovering(false);
  };

  const expanded = proposalMetaList.includes(row.id);

  return (
    <>
      <TableRow
        className={expanded ? classes.rowExpand : classes.row}
        onMouseEnter={enter}
        onMouseLeave={leave}
      >
        <ProposalTableCells
          {...props}
          onRowClick={() => {
            // setExpanded(!expanded);
            setProposalMetaList(row.id);
          }}
          expanded={expanded}
          isHovering={isHovering}
        />
      </TableRow>
      <TableRow>
        <TableCell padding="none" colSpan={7}>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            {/* the proposal metadata, when expanded */}
            <ProposalMetadata row={row} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default ProposalRow;

ProposalRow.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    total_file_count: PropTypes.number,
    total_file_size: PropTypes.number,
    title: PropTypes.string,
    lay_description: PropTypes.string,
    date_approved: PropTypes.string,
    pi: PropTypes.shape(),
    award_doi: PropTypes.string,
    year: PropTypes.number,
  }).isRequired,
  proposalMetaList: PropTypes.arrayOf(PropTypes.number).isRequired,
  setProposalMetaList: PropTypes.func.isRequired,
};
